<template>
    <div class="form">
        <Form
            ref="info"
            :model="info"
            :rules="ruleValidate"
            :label-width="100"
            :viewonly="isView"
        >
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="配套名称" prop="title">
                        <Input
                            v-model="info.title"
                            :maxlength="50"
                            placeholder
                        ></Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="配套总数" prop="num">
                        <input-number
                            v-model="info.num"
                            placeholder
                            :allowDecimal="false"
                        ></input-number>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="品牌参数">
                        <brand-parameters :value="info.children" />
                    </FormItem>
                </Col>
            </Row>

            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="备注" prop="remark">
                        <Input
                            v-model="info.remark"
                            type="textarea"
                            :rows="4"
                            placeholder="0/1000"
                        ></Input>
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import config from '@/config'
import { multiply } from '@/views/common/u-contract'

import {
    assetsFacilityAdd,
    assetsFacilityUpdate,
    assetsFacilityView,
} from '@/api/assets'
import BrandParameters from '_vc/fields/brand-parameters'

export default {
    name: 'a-f-info-form',

    props: {
        id: {
            type: [String, Number],
            default: '',
        },
        actionType: {
            type: [String, Number],
            default: '',
        },
    },

    components: { BrandParameters },

    inject: {
        $modal: {
            default: null,
        },
    },

    data() {
        return {
            info: {
                id: this.id,
                title: '', // 配套名称
                num: '', // 配套总数(个)
                remark: '', // 备注
                pid: '', //
                ver: '', // 版本
                children: [], //品牌参数
            },
            isView: this.actionType === '2' ? true : false,
        }
    },
    computed: {
        ruleValidate() {
            return this.isView
                ? {}
                : {
                      title: [{ required: true, message: '配套名称必填' }],
                      num: [{ required: true, message: '配套总数必填' }],
                  }
        },
    },

    methods: {
        fetch() {
            if (this.id) {
                return assetsFacilityView(this.id)
            } else {
                return Promise.resolve()
            }
        },
    },

    mounted() {
        var $info = this.$refs.info

        // 按钮配置
        const btns = []
        if (this.isView) {
            btns.unshift({
                type: 'default',
                name: 'cancel',
                text: '关闭',
            })
        } else {
            btns.unshift({
                type: 'default',
                name: 'cancel',
                text: '取消',
            })
            btns.unshift({
                type: 'primary',
                name: 'confirm',
                text: '确定',
            })
        }
        this.$modal.updateBtns(btns)

        // 预加载
        this.$modal.beforeEnter((next) => {
            Promise.all([this.fetch()])
                .then((args) => {
                    var [view] = args

                    if (view) {
                        var viewData = view.data.entity
                        // 实体数据
                        if (viewData.entity) viewData = viewData.entity
                        viewData.children.forEach((v) => (v.price /= 100))
                        Object.keys(this.info).forEach(
                            (name) => (this.info[name] = viewData[name])
                        )
                    }
                })
                .finally(() => {
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info
                .validate()
                .then(() => {
                    var formData = Object.assign({}, this.info)
                    const formItem = this.$refs.info.populateData().FormItem[0]
                    formItem.forEach((v) => {
                        v.price = multiply(v.price)
                    })
                    formData.children = JSON.stringify(formItem)
                    if (this.id) {
                        return assetsFacilityUpdate(formData)
                    } else {
                        return assetsFacilityAdd(formData)
                    }
                })
                .then((res) => {
                    if (this.id) {
                        this.$Message.success(this.$t('tips.update.success'))
                    } else {
                        this.$Message.success(this.$t('tips.add.success'))
                    }
                })
                .catch((err) => {
                    options.closeModal = false
                })
                .finally(() => {
                    next()
                })
        })
    },
}
</script>
<style lang="less" scoped></style>
